import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#fbfef5] py-15">
      <div className="container mx-auto px-4 max-w-[85%]">
        <div className="flex flex-col md:flex-row justify-between space-y-8 md:space-y-0 pb-8">
          
          {/* Left Column - Logo and Slogan */}
          <div className="w-full md:w-1/3 text-left">
            <img src="/static/logo-seeurl.svg" alt="Logo" className="h-10 mb-4" />
            <p className="text-[#789a4b] font-semibold" style={{ fontSize: '18px' }}>
              La piattaforma smart, per il dominio che cerchi
            </p>
          </div>

          {/* Right Columns */}
          <div className="flex flex-col md:flex-row justify-end w-full md:w-1/3 space-x-0 md:space-x-6">

            {/* Menu Column */}
            <div className="flex flex-col space-y-2 text-right w-full md:w-1/3 footer-right-to-left">
              <h4 className="text-[#789a4b] font-semibold mb-2" style={{ fontSize: '18px' }}>Menù</h4>
              <ul className="space-y-2 text-[#789a4b]" style={{ fontSize: '16px' }}>
                <li><a href="/">Home Page</a></li>
                <li><a href="/view-domains">Domini</a></li>
              </ul>
            </div>

            {/* Azienda Column */}
            <div className="flex flex-col space-y-2 text-right w-full md:w-1/3 footer-right-to-left">
              <h4 className="text-[#789a4b] font-semibold mb-2" style={{ fontSize: '17px' }}>Azienda</h4>
              <ul className="space-y-2 text-[#789a4b]" style={{ fontSize: '16px' }}>
                <li><a href="/contatti">Contatti</a></li>
                <li><a href="/chi-siamo">Chi Siamo</a></li>
              </ul>
            </div>

            {/* Account Column */}
            <div className="flex flex-col space-y-2 text-right w-full md:w-1/3 footer-right-to-left">
              <h4 className="text-[#789a4b] font-semibold mb-2" style={{ fontSize: '18px' }}>Account</h4>
              <ul className="space-y-2 text-[#789a4b]" style={{ fontSize: '16px' }}>
                <li><a href="/login">Login</a></li>
                <li><a href="/register">Registrazione</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="my-6 border-t-2 border-[#789a4b]" />

        {/* Bottom Row */}
        <div className="flex justify-between items-center text-[#789a4b] footer-center" style={{ fontSize: '14px' }}>
          <p className="text-left font-medium">
            @ Tutti i diritti riservati. - VAY P.iva 02050680442
          </p>
          <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
            <a href="/termini-di-servizio" className="text-[#789a4b] text-sm" style={{ fontWeight: 600 }}>
              Termini di servizio
            </a>
            <a href="/privacy-policy" className="text-[#789a4b] text-sm" style={{ fontWeight: 600 }}>
              Informativa sulla privacy
            </a>
          </div>
        </div>
      </div>

      {/* Custom CSS per dispositivi <1100px */}
      <style jsx>{`
        @media (max-width: 1100px) {
          /* Colonne di destra: Menu, Azienda, Account */
          .footer-right-to-left {
            flex-direction: column !important;
            align-items: flex-start !important;
            width: 100% !important;
            text-align: left !important;
            margin-bottom: 1.5rem; /* aumenta lo spazio tra le colonne */
          }

          /* Bottom row: centra gli elementi */
          .footer-center {
            flex-direction: column !important;
            align-items: center !important;
            text-align: center !important;
            gap: 0.5rem;
            width: 100%; /* Assicura che la sezione prenda tutta la larghezza disponibile */
          }

          /* Centra la frase 'Tutti i diritti riservati' sotto il divisore */
          .footer-center p {
            text-align: center !important;
            width: 100% !important;
            margin-bottom: 1rem;
          }

          /* Links in bottom row: maggiore spazio verticale */
          .footer-center > div {
            align-items: center !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
